import { ButtonIcon, FontAwesomeIcon, Stack, Text } from "@skailer-com/uikit";
import { ReactNode, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface SensitiveValueProps {
  value?: string | number | null;
  fallback?: ReactNode;
  defaultVisible?: boolean;
  maskedDotsCount?: number;
  className?: string;
  textClassName?: string;
  hideToggle?: boolean;
}

export function SensitiveValue({
  value,
  fallback = "-",
  defaultVisible = false,
  maskedDotsCount = 4,
  className,
  textClassName,
  hideToggle = false,
}: SensitiveValueProps) {
  const { t } = useTranslation();
  const [visibility, setVisibility] = useState({ value: defaultVisible, defaultVisible });
  const isVisible =
    visibility.defaultVisible === defaultVisible ? visibility.value : defaultVisible;

  const hasValue = value !== null && value !== undefined && value !== "";

  const hiddenTitle = useMemo(
    () => Array.from({ length: maskedDotsCount }, (_, index) => index),
    [maskedDotsCount]
  );

  if (!hasValue) {
    return <Text className={textClassName}>{fallback}</Text>;
  }

  return (
    <Stack direction="horizontal" items="center" gap="sm" className={twMerge("w-fit", className)}>
      {isVisible ? (
        <Text className={textClassName}>{value}</Text>
      ) : (
        <Stack
          direction="horizontal"
          items="center"
          gap="xs"
          className={twMerge("min-h-5", textClassName)}
        >
          {hiddenTitle.map((item) => (
            <span key={item} aria-hidden="true" className="block h-2 w-2 rounded-full bg-current" />
          ))}
        </Stack>
      )}

      {!hideToggle && (
        <ButtonIcon
          variant="plain"
          size="sm"
          className="shrink-0 text-current"
          aria-label={isVisible ? t("common:hide") : t("common:show")}
          onClick={() => setVisibility({ value: !isVisible, defaultVisible })}
          icon={<FontAwesomeIcon icon={isVisible ? "fa-light fa-eye-slash" : "fa-light fa-eye"} />}
        />
      )}
    </Stack>
  );
}
